import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
// import { UserProvider } from "./context/UserContext.js";
import { UserProvider } from "./context/userContext.js";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// Important to remove bootstrap-react, as the bundle size is too large

// Create MUI theme with custom font
const theme = createTheme({
  typography: {
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
  },
});

// React 18 API
const root = createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <UserProvider>
      <App />
    </UserProvider>
  </ThemeProvider>
);